import React from "react";
import { Container, Row, Col, Card, Button, Popover, PopoverHeader, Spinner } from "reactstrap";
import { connect } from "react-redux";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { elementActions } from "../../../../../store/actions/cms/element/element.action";

import { renderElement } from "../../../../helpers/renderElement";
import { formHelper } from "../../helpers/formHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import JirangoButton from "../../../../components/UI/Buttons/JirangoButton";
import { labelAlignmentButtonDisplay } from "../../../../helpers/labelAlignment";
import StyleWrapper from "../../../template/components/StyleWrapper";
import LanguageToggler from "../../../../../system/LanguageToggler/LanguageToggler";
import { deepClone } from "../../../../../helpers/objectHelper";
import { elementConstants } from "../../../../../constants/cms/form/element/element.constants";
import { handleResponse } from "../../../../../helpers/handleresponse";
import { getKey } from "../../../../../helpers/UrlHelper";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { FloatingCartButton } from "../../../../elements/element/GroupRegistration/GroupRegistration";
import "../FormLayout/FormLayout.css";
import { attendeeActions } from "../../../../../store/actions/attendee/attendee.action";

class PostFormContent extends React.PureComponent {
  state = {
    formIsValid: false,
    submitted: false,
  };
  validators = [];
  validatorList = [];
  componentDidMount() {
    this.validatorList.map((v) => {
      v();
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.form.currentPage !== prevProps.form.currentPage) {
      this.validators = [];
      this.validatorList.map((v) => {
        v();
      });
      window.scrollTo(0, 0);
    }
  }
  isChangeLink = () => {
    const params = new URLSearchParams(this.props.location.search);
    let badgeNo = params.get(getKey("badgeno", params));
    if (badgeNo) return true;
    return false;
  };
  postForm = async () => {
    const { dispatch, attendee } = this.props;
    const form = deepClone(this.props.form);

    /*  if(form.isCropping){
      alert('CROP!')
    } */
    if (this.formIsValid() && !form.isCropping) {
      if (form.survey === true) {
        let orders = Array.from(attendee.orders);
        orders.map((o) => {
          o.formId = form.formId;
          o.surveyCode = /*  parseInt( */ this.props.surveyCode; /* , 36) */
        });
        dispatch(formActions.postSurvey(orders));
        this.setState({ submitted: true });
      } else {
        let orders = Array.from(attendee.orders);
        if (attendee.payMethod) {
          orders.map((o) => {
            o.payMethod = attendee.payMethod;
            o.formId = form.formId;
          });
        } else {
          orders.map((o) => {
            o.formId = form.formId;
          });
        }
        /*      let isChangeLink = this.isChangeLink(); */
        let dto = [];
        orders.map((o) => {
          let order = {
            orderId: o.orderId ? o.orderId : null,
            eventIds: [],
          };

          if (!o.discounts) o.discounts = [];

          if (o.orderRow) {
            o.orderRow.map((or) => {
              if (o.discount && or.amount > 0) {
                if (o.discount.includes("%") && or.eventId != o.eventId) {
                  or.discount = parseFloat(o.discount);
                } else {
                  or.discount = parseFloat(o.discount);
                }
              }
              order.eventIds.push(or.eventId);
            });
          }
          if (order.eventIds.length > 0) {
            dto.push(order);
          }
        });
        if (dto.length > 0) {
          const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dto),
          };
          fetch(`./api/attendee/statusrange/${form.sqlStateNo}`, requestOptions)
            .then(handleResponse)
            .then((response) => {
              if (response.available) {
                dispatch(formActions.post(orders, form.formId));
                this.setState({ submitted: true });
              } else {
                alert("OrderRowFull");
              }
            })
            .catch((err) => console.error(err));
        } else {
          dispatch(formActions.post(orders));
          this.setState({ submitted: true });
        }
      }
    }
  };

  formIsValid = () => {
    let invalidElements = false;
    console.log("validate");
    this.validators.map((validator) => {
      if (typeof validator === "function" && !validator()) {
        invalidElements = true;
      }
    });
    if (invalidElements) return false;
    return true;
  };
  getValidator = (validator) => {
    if (validator !== undefined && typeof validator === "function") {
      this.validators.push(validator);
    }
  };
  updateValidators = (validator, clear) => {
    console.log("clear", clear);
    if (typeof validator === "function" && !clear) {
      this.validatorList.push(validator);
    } else if (typeof validator === "function" && clear) {
      let index = -1;
      this.validatorList.map((v, i) => {
        if (v === validator) {
          index = i;
        }
      });
      console.log(this.validatorList);
      if (index > -1) {
        this.validatorList.splice(index, 1);
      }
    } else {
      this.validatorList.map((validator) => {
        validator();
      });
    }
  };

  allowAdd = () => {
    return this.formIsValid();
  };

  togglePage = (page) => {
    const { dispatch } = this.props;
    const { form, attendee } = this.props;
    const isAllowed = this.formIsValid();
    if (!isAllowed && page > this.props.form.currentPage) return;
    if (page <= form.pages || page >= 1) {
      if (
        form.settings.changeToGroupLeaderOnSpecificPage == true &&
        form.settings.specificPage &&
        parseInt(form.settings.specificPage) > 0 &&
        !this.props.cms.editMode &&
        attendee.orders.length > 1 &&
        page == form.settings.specificPage
      ) {
        var leader = attendee.orders.find((o) => o.leader == true);
        if (leader) {
          dispatch(attendeeActions.setActivePersonNo(attendee.orders.indexOf(leader)));
        } else {
          leader = attendee.orders.find((o) => o.orderId == o.orderGroupId);
          dispatch(attendeeActions.setActivePersonNo(attendee.orders.indexOf(leader)));
        }
      }
      dispatch(formActions.scrollPage(page, () => {}));
    }
  };
  getElements = () => {
    const { formElements, selectedElement } = this.props.form;
    const { form, template } = this.props;
    if (!formElements) return [];
    return Array.from(
      formElements.filter(
        (el) => el.parentId == null && el.page == form.currentPage /* &&
          (el.data.hidden === false || el.data.hidden === undefined) */
      )
    );
  };
  isAuthorized = () => {
    const { form, attendee } = this.props;
    if (form.settings.authorizedFormMode === true) {
      if (attendee && attendee.orders && attendee.orders.length > 0 && this.props.attendee.orders[0].orderId !== undefined) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  };
  render() {
    const { formElements, selectedElement } = this.props.form;
    const { form, template, cms } = this.props;
    if (!cms.editMode && !this.isAuthorized()) {
      return (
        <div
          style={{
            height: "80vh",
            margin: "auto",
            padding: "28vh",
            textAlign: "center",
            fontSize: "20px",
            color: "#595959",
          }}
        >
          <LockOutlinedIcon style={{ fontSize: "50px", color: "inherit", marginBottom: "20px" }} />
          <br />
          <SystemLabel groupName={"Form.Edit"} name="YouAreNotAuthorizedToRegister" languageCode={this.props.form.languageCode || "swe"} />
        </div>
      );
    }
    return (
      <div className="animated fadeIn">
        {/* <Container
          className="responsive-container"
          style={
            template && {
              ...template.content.content,
              width: "100%",
              overflow: "visible"
            }
          }
        > */}
        {formElements.find((f) => f.type == elementConstants.GROUP_REGISTRATION) &&
        !this.props.cms.editMode &&
        ((this.props.form.settings.changeToGroupLeaderOnSpecificPage == true && this.props.form.settings.specificPage != this.props.form.currentPage) ||
          this.props.form.settings.changeToGroupLeaderOnSpecificPage == false) ? (
          <FloatingCartButton {...this.props} />
        ) : null}
        {this.getElements().map((el, index) => {
          return (
            <React.Fragment key={index}>
              <Row
                key={index}
                style={{
                  width: "100%",
                  margin: "0px",
                  backgroundColor: "unset",
                }}
              >
                <Col
                  style={{
                    width: "100%",
                    display: "inline-flex",
                    padding: "0px",
                  }}
                >
                  <Col
                    style={{
                      maxWidth: "100%",
                      backgroundColor: "unset",
                      padding: "0px",
                    }}
                  >
                    {renderElement(el.type, el, null, null, this.getValidator, this.updateValidators,this.allowAdd)}
                  </Col>
                </Col>
              </Row>
            </React.Fragment>
          );
        })}
        {formElements.length > 0 && form.currentPage === form.pages && form.pages === 1 && form.settings !== undefined && form.settings.submit !== undefined && !form.settings.submit.hidden ? (
          <Row
            style={{
              ...labelAlignmentButtonDisplay(form.settings.submit.alignment),
              display: "inline-flex",
              margin: "0px",
              padding: "10px",
              width: "100%",
            }}
          >
            <Col
              style={{
                ...labelAlignmentButtonDisplay(form.settings.submit.alignment),
                display: "inline-flex",
                padding: "0px",
              }}
            >
              <div>
                <JirangoButton disabled={(this.state.submitted && !form.submitError) || this.props.disabled === true} onClick={this.postForm} style={template && template.content.button}>
                  {form.settings.submit.labels.find((l) => {
                    return (l.languageCode.code || l.languageCode) === form.languageCode;
                  }).text || form.settings.submit.defaultLabel}{" "}
                  {this.state.submitted && !form.submitError ? <Spinner style={{ width: "1.2rem", height: "1.2rem" }} color="light" /> : null}
                </JirangoButton>
              </div>
            </Col>
          </Row>
        ) : null}
        {form && form.pages > 1 ? (
          <Row
            style={{
              display: "inline-flex",
              padding: "10px",
              width: "100%",
              minHeight: "70px",
              margin: "0px",
            }}
          >
            <Col style={{ textAlign: "left", padding: "0px" }}>
              {parseInt(form.currentPage) > 1 && form.settings !== undefined && form.settings.navigation !== undefined && form.settings.navigation.previous !== undefined ? (
                <JirangoButton onClick={() => this.togglePage(parseInt(form.currentPage) - 1)} style={template && template.content.button}>
                  {form.settings.navigation.previous.labels.find((l) => {
                    return (l.languageCode.code || l.languageCode) === form.languageCode;
                  }).text ? (
                    form.settings.navigation.previous.labels.find((l) => {
                      return (l.languageCode.code || l.languageCode) === form.languageCode;
                    }).text
                  ) : (
                    <i className="fa fa-chevron-left" />
                  )}
                </JirangoButton>
              ) : null}
            </Col>

            <Col style={{ textAlign: "right", padding: "0px" }}>
              {parseInt(form.currentPage) < form.pages && form.settings !== undefined && form.settings.navigation !== undefined && form.settings.navigation.next !== undefined ? (
                <JirangoButton onClick={() => this.togglePage(parseInt(form.currentPage) + 1)} style={template && template.content.button}>
                  {form.settings.navigation.next.labels.find((l) => {
                    return (l.languageCode.code || l.languageCode) === form.languageCode;
                  }).text ? (
                    form.settings.navigation.next.labels.find((l) => {
                      return (l.languageCode.code || l.languageCode) === form.languageCode;
                    }).text
                  ) : (
                    <i className="fa fa-chevron-right" />
                  )}
                </JirangoButton>
              ) : null}
              {form.currentPage === form.pages &&
              form.settings !== undefined &&
              form.settings.submit !== undefined &&
              form.settings.submit.labels !== undefined &&
              !form.settings.submit.hidden /* .find(l => {
                  return l.languageCode === form.languageCode;
                }).text !== "" */ ? (
                <JirangoButton disabled={(this.state.submitted && !form.submitError) || this.props.disabled === true} onClick={this.postForm} style={template && template.content.button}>
                  {form.settings.submit.labels.find((l) => {
                    return (l.languageCode.code || l.languageCode) === form.languageCode;
                  }).text !== ""
                    ? form.settings.submit.labels.find((l) => {
                        return (l.languageCode.code || l.languageCode) === form.languageCode;
                      }).text
                    : form.settings.submit.defaultLabel}{" "}
                  {this.state.submitted && !form.submitError ? <Spinner style={{ width: "1.2rem", height: "1.2rem", borderWidth: "3px" }} color="light" /> : null}
                </JirangoButton>
              ) : null}
            </Col>
          </Row>
        ) : null}
        {/*    <LanguageToggler /> */}
        {/*   </Container> */}
      </div>
      /*    </div> */
    );
  }
}

function mapStateToProps(state) {
  return {
    cElements: state.element,
    alert: state.alert,
    cms: state.cms,
    form: state.form,
    template: state.template.template,
    attendee: state.attendee,
  };
}

export default connect(mapStateToProps)(PostFormContent);
